import React from "react";
import { withRouter } from "react-router-dom";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import ErrorBoundary from "./ErrorBoundary";
import Button from "./utilities/Button";
import loading from "../img/loading.svg";
import bcrypt from "bcryptjs";

class CreateUser extends React.Component {
  constructor(props) {
    super();
    this.state = {
      password: null,
      loading: false,
      error: false
    };
  }

  handleSubmit = e => {
    e.preventDefault();
    const id = this.props.adminId;
    let pass = this.state.password;

    this.setState({
      loading: true,
      success: false
    });

    if (pass && pass.length > 0) {
      const SALT_ROUNDS = 10;
      const salt = bcrypt.genSaltSync(SALT_ROUNDS);
      pass = bcrypt.hash(pass, salt).then(password => {
        this.props
          .updateUserMutationWithPassword({
            variables: { id, password }
          })
          .then(() => {
            this.setState({ loading: false, password: null, success: true });
          })
          .catch(e => {
            this.setState({ loading: false, error: true });
            console.error("update admin", e);
          });
      });
    } else {
      this.setState({ loading: false, error: true });
    }
  };

  render() {
    return (
      <ErrorBoundary>
        <div className="column is-4">
          <div className="card">
            <header className="card-header">
              <h1 className="card-header-title has-text-centered is-size-3">
                Editer Admin
              </h1>
            </header>
            <div className="card-content  has-text-left">
              <form onSubmit={this.handleSubmit}>
                <div className="field">
                  <label className="label">Nouveau mot de passe</label>
                  <div className="control">
                    <input
                      className={`input  ${this.state.error
                        ? "is-danger"
                        : ""}`}
                      type="password"
                      onChange={e =>
                        this.setState({ password: e.target.value })}
                    />
                  </div>
                </div>
                <div className="field  has-text-centered">
                  {this.state.loading ? (
                    <figure
                      style={{
                        marginBottom: "-10px"
                      }}
                      className="image is-32x32"
                    >
                      <img alt="loading" src={loading} />
                    </figure>
                  ) : null}
                  <Button
                    text="Changer mot de passe"
                    type="submit"
                    disabled={this.state.loading}
                  />
                  {this.state.success ? (
                    <div className="field  has-text-centered has-text-centered has-text-success">
                      Mot de passe a été mis à jour avec succès!
                    </div>
                  ) : null}
                </div>
              </form>
            </div>
          </div>
        </div>
      </ErrorBoundary>
    );
  }
}

const UPDATE_USER_PASSWORD = gql`
  mutation updateUserMutationPassword($id: ID!, $password: String) {
    updateUser(id: $id, password: $password) {
      id
    }
  }
`;

export default compose(
  graphql(UPDATE_USER_PASSWORD, {
    name: "updateUserMutationWithPassword"
  })
)(withRouter(CreateUser));



// WEBPACK FOOTER //
// ./src/components/EditAdmin.js